module.exports = __webpack_public_path__ + "img/Germantown_Grille@3x.fb9c5d5b.webp";